import { z } from "zod";

const commentInputFormDataShape = z.object({
  bodyAsPlainText: z
    .string()
    .trim()
    .nonempty("O comentário é obrigatório")
    .min(3, "O comentário deve ter no mínimo 3 caracteres")
    .max(12288, "O comentário deve ter no máximo 12288 caracteres"),
});

export type CommentInputFormData = z.infer<typeof commentInputFormDataShape>;
export default commentInputFormDataShape;
